<template>
  <div class="app-container">
    <el-tabs v-model="tabName" type="card" @tab-click="handleClick">
      <el-tab-pane label="未发货" name="unshipped"></el-tab-pane>
      <el-tab-pane label="已发货" name="shipped"></el-tab-pane>
    </el-tabs>
    <list ref="list" v-if="tabName == 'unshipped'">
      <template slot="column">
        <!-- <el-table-column label="操作" fixed="right" align="center" width="90">
          <template slot-scope="{row}">
            <el-button type="text" @click="openPrint(row)">打印</el-button>
            <el-button type="text" @click="openPrintWithSend(row)">发货</el-button>
          </template>
</el-table-column> -->
      </template>
    </list>
    <shipped-list ref="shippedList" v-if="tabName == 'shipped'">

    </shipped-list>
  </div>
</template>
<script>
import curdMixins from "@/mixins/curd";
import list from "@/components/orders/list";
import shippedList from "@/components/orders/shippedList";

export default {
  name: "orders",
  mixins: [curdMixins],
  components: { list, shippedList },
  data() {
    return {
      tabName: "unshipped",
    }
  },
  mounted() { },
  methods: {
    reload() {
      this.$nextTick(() => {
        if (this.tabName == "unshipped") {
          this.$refs.list.getData();
        } else {
          this.$refs.shippedList.getData();
        }
      })
    },
    handleClick() {
      this.reload();
    }
  }
}
</script>
<style lang="scss"></style>